import React, { useEffect } from 'react'
import { useState } from 'react'
import { Link, useParams } from 'react-router-dom'

import Header from '../common/Header'
import SideMenu from '../common/SideMenu'

import './Shop.css'
import { useTranslation } from "react-i18next";


const Shop = ({ onlyShop }) => {
  const { t } = useTranslation();
  const { shop } = useParams();

  const [effects, setEffects] = useState([]);

  const updateEffects = (originals) => {
    if (shopInfo.effectType <= 1000) {
      setEffects([
        `${process.env.REACT_APP_ASSET_URL}/static/gacha-effect/gacha_effect${shopInfo.effectType}-1.mp4`,
        `${process.env.REACT_APP_ASSET_URL}/static/gacha-effect/gacha_effect${shopInfo.effectType}-2.mp4`,
        `${process.env.REACT_APP_ASSET_URL}/static/gacha-effect/gacha_effect${shopInfo.effectType}-3.mp4`,
        `${process.env.REACT_APP_ASSET_URL}/static/gacha-effect/gacha_effect${shopInfo.effectType}-4.mp4`,
      ]);
    } else {
      if (originals) {
        const original = originals.find(o => o.id === Number(shopInfo.effectType));
        if (original) {
          setEffects([
            `${process.env.REACT_APP_ASSET_URL}${original.items.find(i => i.rank === 1)?.path_with_version}`,
            `${process.env.REACT_APP_ASSET_URL}${original.items.find(i => i.rank === 2)?.path_with_version}`,
            `${process.env.REACT_APP_ASSET_URL}${original.items.find(i => i.rank === 3)?.path_with_version}`,
            `${process.env.REACT_APP_ASSET_URL}${original.items.find(i => i.rank === 4)?.path_with_version}`,
          ]);
        }
      }
    }
  }

  
  useEffect(() => {
    let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
    if (xsrfToken) {
      xsrfToken = xsrfToken.split('=')[1]
    }
    let token = document.cookie.split('; ').find(row => row.startsWith('token'));
    if (token) {
      token = token.split('=')[1]
    }
    fetch(process.env.REACT_APP_API_URL + '/api/shop', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-XSRF-TOKEN': decodeURIComponent(xsrfToken),
        'Bearer': decodeURIComponent(token),
      },
      credentials: 'include',
    })
      .then(response => response.json())
      .then(data => {
        let shop = data.shop;
        const effectType = shop.effect_pattern ? shop.effect_pattern : 1;
        setShopInfo({
          userId: shop.shop_user_id,
          name: shop.name,
          postal_code: shop.postal_code,
          address: shop.address,
          email: shop.email,
          url: shop.url,
          personInCharge: shop.person_in_charge,
          specialCommercialLaw: shop.special_commercial_law,
          privacyPolicy: shop.privacy_policy,
          useTerm: shop.use_terms,
          secondhandDealerLicenseNumber: shop.secondhand_dealer_license_number,
          faviconUrl: shop.favicon_url ? shop.favicon_url : "/static/default/favicon.png",
          logoUrl: shop.logo_url ? shop.logo_url : "/static/default/logo.png",
          designType: shop.design_pattern ? shop.design_pattern : 1,
          effectType: effectType,
          originalEffectPattern: shop.original_effect_pattern,
          shipFee: shop.ship_fee,
          noteTitle: shop.note_title,
          noteContent: shop.note_content,
          holdDays: shop.hold_days,
          shippingAfterDays: shop.shipping_after_days,
          gtagId: shop.gtag_id,
          isShoppaymentEnabled: shop.is_shoppayment_enabled,
          gtmId: "",
          facebookPixelId: "",
          twitterPixelId: "",
          default_country: shop.default_country ? shop.default_country : 0,
        })

        if (shop.info_imgs) {
          setImageUpdateInfo(shop.info_imgs);
        }
        if (shop.info_urls)
          setUrlUpdateInfo(shop.info_urls);

        // updateEffects(shop.original_effect_pattern)
      }).catch(error => {
        // window.location.href = '/' + shop;
      });
  }, [])

  const [shopInfo, setShopInfo] = useState({
    userId: '',
    name: '',
    postal_code: '',
    address: '',
    email: '',
    url: '',
    personInCharge: '',
    specialCommercialLaw: '',
    privacyPolicy: '',
    useTerm: '',
    secondhandDealerLicenseNumber: '',
    faviconUrl: '',
    logoUrl: '',
    designType: 1,
    effectType: 1,
    shipFee: 0,
    note_title: "",
    note_content: "",
    hold_days: "",
    shippingAfterDays: "",
    gtagId: "",
    isShoppaymentEnabled: 0,
    gtmId: "",
    facebookPixelId: "",
    twitterPixelId: "",
    default_country: 0,
  });

  const [imageUpdateInfo, setImageUpdateInfo] = useState([]);
  const [urlUpdateInfo, setUrlUpdateInfo] = useState([]);

  useEffect(() => {
    updateEffects(shop.original_effect_pattern);
  }, [shopInfo.effectType])

  const CreateShopUpdateInfo = ({ }) => {
    
    return [...Array(5)].map((_, i) => {
      if (imageUpdateInfo[i]) {
        return (
          <div className="shop-info-img-wrapper" key={"shop-info-img-wrapper" + i}>
            <div className="shop-info-img">
              <img src={process.env.REACT_APP_ASSET_URL + imageUpdateInfo[i]} />
            </div>
            {urlUpdateInfo[i]}
          </div>
        );
      }
    });
  }

  return (
    <>
      <Header />
      <SideMenu onlyShop={onlyShop} />
      <div className="shop">
        <div className="shop-content">
          <div className="shop-title">{t('shop.title1')}</div>
          <div className="shop-create">
            <Link to={`/${shop}/shop-edit`}>
              <button className="shop-create-button">{t('shop.edit')}</button>
            </Link>
            <Link to={`/${shop}/logout`}>
              <button className="shop-logout-button">{t('shop.logout')}</button>
            </Link>
          </div>
          <div className='clearfix'></div>
          <div className="shop-sub-title">{t('shop.information')}</div>
          <dl className="shop-info">
            <dt className="shop-info-title">{t('shop.logo')}</dt>
            <dd className="shop-info-text">
              <img className="shop-info-image" src={process.env.REACT_APP_ASSET_URL + shopInfo.logoUrl} alt={t('shop.logo')} />
            </dd>
            <dt className="shop-info-title">{t('shop.favicon')}</dt>
            <dd className="shop-info-text">
              <img className="shop-info-favicon" src={process.env.REACT_APP_ASSET_URL + shopInfo.faviconUrl} alt={t('shop.favicon')} />
            </dd>
            <dt className="shop-info-title">{t('shop.id')}</dt>
            <dd className="shop-info-text">{shopInfo.userId}</dd>
            <dt className="shop-info-title">{t('shop.password')}</dt>
            <dd className="shop-info-text">********</dd>
            <dt className="shop-info-title">{t('shop.name')}</dt>
            <dd className="shop-info-text">{shopInfo.name}</dd>
            <dt className="shop-info-title">{t('shop.default_country')}</dt>
            <dd className="shop-info-text">
              {shopInfo.default_country == "0" ? "日本"
                    : shopInfo.default_country == "1" ? "香港"
                    : shopInfo.default_country == "2" ? "台湾"
                    : shopInfo.default_country == "3" ? "シンガポール"
                    : "日本"
                  }
            </dd>
            <dt className="shop-info-title">{t('shop.postal_code')}</dt>
            <dd className="shop-info-text">{shopInfo.postal_code}</dd>
            <dt className="shop-info-title">{t('shop.address')}</dt>
            <dd className="shop-info-text">{shopInfo.address}</dd>
            <dt className="shop-info-title">{t('shop.email')}</dt>
            <dd className="shop-info-text">{shopInfo.email}</dd>
            <dt className="shop-info-title">{t('shop.url')}</dt>
            <dd className="shop-info-text">{shopInfo.url}</dd>
            <dt className="shop-info-title">{t('shop.manager')}</dt>
            <dd className="shop-info-text">{shopInfo.personInCharge}</dd>
            <dt className="shop-info-title">{t('shop.law')}</dt>
            <dd className="shop-info-text">
              <textarea className="shop-info-textarea" value={shopInfo.specialCommercialLaw ?? ''} readOnly />
            </dd>
            <dt className="shop-info-title">{t('shop.privacy')}</dt>
            <dd className="shop-info-text">
              {/* テキストエリア readonly */}
              <textarea className="shop-info-textarea" readOnly value={shopInfo.privacyPolicy ?? ''} />
            </dd>
            <dt className="shop-info-title">{t('shop.service')}</dt>
            <dd className="shop-info-text">
              {/* テキストエリア readonly */}
              <textarea className="shop-info-textarea" readOnly value={shopInfo.useTerm ?? ''} />
            </dd>
            <dt className="shop-info-title">{t('shop.number')}</dt>
            <dd className="shop-info-text">{shopInfo.secondhandDealerLicenseNumber}</dd>
            <dt className="shop-info-title">{t('shop.point')}</dt>
            <dd className="shop-info-text">{shopInfo.shipFee} pt</dd>
            <dt className="shop-info-title">{t('shop.Pending')}</dt>
            <dd className="shop-info-text">
              {
                shopInfo.holdDays ? 
                  <>
                  {t('shop.day1')}{shopInfo.holdDays} {t('shop.day2')}
                  </>
                :
                  <>
                  {t('shop.deadline')}
                  </>
              }
            </dd>
            <dt className="shop-info-title">{t('shop.days')}</dt>
            <dd className="shop-info-text">
              {
                shopInfo.shippingAfterDays ?
                  <>
                    {t('shop.day1')}{shopInfo.shippingAfterDays} {t('shop.day2')} ({t('shop.note')})
                  </>
                  :
                  <>
                    {t('shop.none')}
                  </>
              }
            </dd>
          </dl>
          <div className="line"></div>
          <div className="shop-sub-title">{t('shop.display')}</div>
          <dl className="shop-info">
            <dt className="shop-info-title">{t('shop.news')}</dt>
            <dd className="shop-info-text">
              <div className="shop-info-imgs">
                <CreateShopUpdateInfo key={"shop-info-imgs"} />
              </div>
            </dd>
            <dt className="shop-info-title">{t('shop.design')}</dt>
            <dd className="shop-info-text">
              <div className="shop-design-img">
                <img src={`${process.env.REACT_APP_ASSET_URL}/static/design-pattern/design_pattern${shopInfo.designType}.png`} alt={t('shop.design')} />
                パターン{shopInfo.designType}
              </div>
            </dd>
            <dt className="shop-info-title">{t('shop.effect')}</dt>
            <dd className="shop-info-text">
              <div className="shop-effect-imgs">
                {effects.map((e, index) => (
                  <div className="shop-effect-img" key={"shop-effect-img" + index}>
                    <video src={e} autoPlay muted loop playsInline></video>
                    {index + 1}{t('shop.rank')}
                  </div>
                ))}
              </div>
            </dd>
            <dt className="shop-info-title">{t('shop.gache1')}</dt>
            <dd className="shop-info-text">{shopInfo.noteTitle}</dd>
            <dt className="shop-info-title">{t('shop.gache2')}</dt>
            <dd className="shop-info-text">
              <textarea className="shop-info-textarea" readOnly value={shopInfo.noteContent ?? ''} />
            </dd>
            <dt className="shop-info-title">Google Analytics ID</dt>
            <dd className="shop-info-text">{shopInfo.gtagId}</dd>
          </dl>

        </div>
      </div>
    </>
  )
}

export default Shop